module.exports = __webpack_public_path__ + "img/Hägglunds.e2545caf.svg";